module.exports = __webpack_public_path__ + "img/opensans-light-webfont.aba049e2.svg";